import {Box} from "@mui/material"
import {SvgIconProps} from "@mui/material"
import {green, grey} from "@mui/material/colors"
import {cloneElement, ReactElement} from "react"

import {SxPropsMap} from "../../helper/HelperType"
import {InfoBox, Padding} from "./InfoBox"
import {InfoColorBoxList} from "./InfoColorBoxList"

const SX: SxPropsMap = {
    box: {position: "relative", display: "flex", alignItems: "center", justifyContent: "center"},
    badge: {
        position: "absolute", color: "white", fontSize: "8px", fontWeight: "bold",
        minWidth: "12px", height: "12px", display: "flex", justifyContent: "center", alignItems: "center",
        borderRadius: "50%", padding: "2px", textTransform: "uppercase",
    }
}

type Item = { icon: ReactElement<SvgIconProps>, label: string, active: boolean, iconColor?: string, badge?: string }
type Props = {
    items: Item[],
    label?: string,
}

export function InfoBoxList(props: Props) {
    const {items, label} = props
    const titleItems = items.map(item => ({
        label: item.label,
        color: item.active ? "success" : "default",
    }))

    return (
        <InfoBox tooltip={<InfoColorBoxList items={titleItems} label={label}/>} padding={Padding.Small}>
            {items.map((item, index) => {
                const defaultColor = item.iconColor ?? "default"
                const color = item.active ? defaultColor : "text.disabled"
                const background = item.active ? green[600] : grey[800]
                return (
                    <Box key={index} sx={SX.box}>
                        {item.badge && <Box sx={{...SX.badge, background}}>{item.badge}</Box>}
                        {cloneElement(item.icon, {sx: {color}})}
                    </Box>
                )
            })}
        </InfoBox>
    )
}

